export default "__VITE_ASSET__b2ced101__"